import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { ChangeEvent } from "react";
import { ISport } from "src/services";
import { SPORT_TOGGLE_INPUT_LABEL } from "./constants";
import { styles } from "./styles";
import { ISportCheckboxesProps } from "./types";

export const SportCheckboxes = withStyles(styles)(
  ({
    classes,
    currentCoach,
    includedSports,
    setIncludedSports,
  }: ISportCheckboxesProps) => {
    const shouldShowSports = currentCoach.sports?.length > 1;
    const includedSportIds = includedSports.map((sport) => sport.id);

    const handleOnChange = (e: ChangeEvent, sport: ISport) => {
      const element = e.target as HTMLInputElement;
      const checked = element.checked;
      if (checked) {
        setIncludedSports((prevIncludedSports) => [
          ...prevIncludedSports,
          sport,
        ]);
      } else {
        setIncludedSports(
          includedSports.filter(
            (includedSport) => includedSport.id !== sport.id
          )
        );
      }
    };

    return (
      <>
        {shouldShowSports && (
          <>
            <Typography variant="subtitle1">
              {SPORT_TOGGLE_INPUT_LABEL}
            </Typography>
            <Box display="flex" gridGap="1rem">
              {currentCoach.sports?.map((sport) => (
                <Box className={classes.checkboxWrapper}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={includedSportIds.indexOf(sport.id) !== -1}
                        onChange={(e) => handleOnChange(e, sport)}
                      />
                    }
                    label={sport.name}
                  />
                </Box>
              ))}
            </Box>
          </>
        )}
      </>
    );
  }
);



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/components/SportCheckboxes/SportCheckboxes.tsx